






























































































































































import {
  Vue, Component,
} from 'vue-property-decorator';
import AdminBrandAssetCard from '../../components/admin/AdminBrandAssetCard.vue';
import brandModule from '../../store/modules/brand.module';
import { BrandAssetWrite, Category } from '../../common/types';
import tagModule from '../../store/modules/tag.module';
import categoryModule from '../../store/modules/category.module';
import { eventBus } from '../../main';
import { ASSET_CREATED } from '../../common/constants';
import errorModule from '../../store/modules/error.module';
import BrandAsset from '../../common/model/BrandAsset';
import { VIDEO_ID } from '../../common/config';

@Component({
  components: {
    AdminBrandAssetCard,
  },
})
export default class AdminAssetsPage extends Vue {
  newAssetButtonPressed = false;

  newAsset: BrandAssetWrite = {
    title: '',
    description: '',
    tags: [],
    category: '',
    img: require('@/assets/admin/placeholder.jpg'),
    brand_id: '',
    featured: false,
  };

  brandModule = brandModule;

  itemsPerPageArray = [16, 24, 32];

  search = '';

  filter = {};

  sortDesc = false;

  page = 1;

  itemsPerPage = 16;

  selectedCategory = '';

  categories: Array<Category> = [
    { title: 'All Categories', id: '' },
  ];

  get brandAssets(): Array<BrandAsset> {
    const nonVideoAssets = brandModule.assets.filter(asset => asset.category && asset.category.id !== VIDEO_ID);
    if (this.selectedCategory) {
      return nonVideoAssets.filter(asset => asset.category.id === this.selectedCategory)
    }
    return nonVideoAssets;
  }

  get numberOfPages(): number {
    return Math.ceil(this.brandAssets.length / this.itemsPerPage)
  }

  get secondaryColor(): string {
    return '#000000';
  }

  async created(): Promise<void> {
    eventBus.$on(ASSET_CREATED, this.toggleDialog);
    if (!brandModule.brand) {
      await brandModule.fetchBrand(this.$router.currentRoute.params.brandId);
      if (errorModule.hasError) {
        errorModule.clearError();
        return;
      }
    }
    const promiseArray: Array<Promise<void>> = [];
    if (categoryModule.categories.length === 0) {
      promiseArray.push(categoryModule.fetchCategories());
    }
    if (tagModule.tags.length === 0) {
      promiseArray.push(tagModule.fetchTags());
    }
    await Promise.all(promiseArray);
    if (errorModule.hasError) {
      errorModule.clearError();
    }
    for (let assetIndex = 0; assetIndex < this.brandAssets.length; assetIndex += 1) {
      const asset = this.brandAssets[assetIndex];
      this.categories.push(asset.category);
    }
  }

  toggleDialog(): void {
    this.newAssetButtonPressed = false;
  }

  nextPage(): void {
    if (this.page + 1 <= this.numberOfPages) this.page += 1
  }

  formerPage(): void {
    if (this.page - 1 >= 1) this.page -= 1
  }

  updateItemsPerPage(number: number): void {
    this.itemsPerPage = number
  }
}
